import React, { lazy } from 'react';
import { PrivateRoute } from '../../components/HasRights/HasRights';
import { Permissions } from '../../const/permissions';
import appRoutes from '@/configs/routes';



const PagePopups = lazy(() => import('../../domains/Other/pages/Popups/PagePopups'));
const PagePopupCreate = lazy(() => import('../../domains/Other/pages/Popups/PagePopupCreate'));
const PagePopupEdit = lazy(() => import('../../domains/Other/pages/Popups/PagePopupEdit'));
const PagePopupDetails = lazy(() => import('../../domains/Other/pages/Popups/PagePopupDetails'));

export const popupsRoutes = ({ urlPrefix = null }) => [
  {
    path: appRoutes.urlPagePopups({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.LIST ]}>
        <PagePopups />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPagePopupCreate({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.CREATE ]}>
        <PagePopupCreate />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPagePopupEdit({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.EDIT ]}>
        <PagePopupEdit />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPagePopupDetails({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.FIND ]}>
        <PagePopupDetails />
      </PrivateRoute>
    ),
  },
];
